import {messagesService} from "@dv5/api"
import {CanvasSettings} from "@dv5/domain"

class CanvasSettingsService {
    updateSettings(canvasId: string, settings: Partial<CanvasSettings>) {
        messagesService.send('canvas.update-settings', {
            canvasId,
            visualSettings: {displayGrid: settings.displayGrid},
            positionSettings: {alignToGrid: settings.alignToGrid},
            widgetSettings: {
                ...(settings.markdownComments !== undefined && {markdownComments: settings.markdownComments}),
                ...(settings.readOnly !== undefined && {readOnly: settings.readOnly}),
            },
        })
    }
}

export const canvasSettingsService = new CanvasSettingsService()
